import ROUTES from '../routes';
import IncomingTransactions from '../hoc/incoming/incoming';
import IncomingTransaction from '../hoc/incoming/transaction';
import ExpandedGeneralLedgerTransaction from '../hoc/transactions/expanded-general-ledger-panel';

const IncomingRoutes = {
  path: ROUTES.INCOMING,
  element: <IncomingTransactions />,
  children: [
    {
      path: ROUTES.INCOMING_TRANSACTION,
      element: <IncomingTransaction />,
    },
    {
      path: ROUTES.INCOMING_TRANSACTION_CREATE,
      element: <IncomingTransaction />,
    },
    {
      path: ROUTES.INCOMING_TRANSACTION_GL,
      element: <ExpandedGeneralLedgerTransaction backLink={ROUTES.INCOMING} />,
    },
  ],
};

export default IncomingRoutes;
